import { render } from "./NumerologyCalculator.vue?vue&type=template&id=70ca3049&scoped=true"
import script from "./NumerologyCalculator.vue?vue&type=script&lang=js"
export * from "./NumerologyCalculator.vue?vue&type=script&lang=js"

import "./NumerologyCalculator.vue?vue&type=style&index=0&id=70ca3049&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70ca3049"]])

export default __exports__